import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { addWinners } from "../../redux/actions";
import { PopupContainer } from "./PopupContainer";
import InfiniteScroll from 'react-infinite-scroll-component';
import kitcut from "../../utils/kitcut";
import hyphen from "../../utils/hyphen";

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/manipulation';
import { getPoints } from "../../utils/getPoints";

export const WinnersPopup = ({id, winners, allWinners, pagination, game, close, title}) => {
    const dispatch = useDispatch()
    const lang = useSelector(state => state.app.currentLang)
    const langName = useSelector(state => state.app.currentLangName)

    const [bodyWidth, setBodyWidth] = useState(0);

    let halfOfPages = (pagination.perPage / 2) * 74;
    let scrollThreshold = (halfOfPages !== 0 ? halfOfPages + "px" : 0.8)

    const fn = (number) => {
        if (parseInt(number) < 10) {
            return '0' + number;
        }
        return number;
    }
    let heightVar = 350
    if (540 <= bodyWidth && bodyWidth <= 991)  {
        heightVar = 480
    }
    useEffect(() => {
        setBodyWidth(window.innerWidth);
        const handleResize = (event) => {
            setBodyWidth(event.target.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    let heightOfContainer = (winners.length < 5) ? null : heightVar;
    if (!Array.isArray(winners)) {
        return (null)
    }
    return (
        <PopupContainer popup={winners} popupName={title} heading={lang.games4} close={() => dispatch(close())}>
            {
                winners.length === 0
                    ? <div className="winnersPopup__empty">{lang.games12}</div>
                    :
                    <InfiniteScroll
                        pageStart={0}
                        next={() => { dispatch(addWinners(id, winners, pagination, game)) }}
                        hasMore={!allWinners}
                        dataLength={winners.length}
                        height={heightOfContainer}
                        scrollThreshold={scrollThreshold}
                        style={{
                            "margin": "0px 0px -26px 0px",
                            "paddingRight": "10px"
                        }}
                    >
                        {
                            winners.map(function (item, index) {
                                let a = item.createdAt.split(' ')[0].split('-')
                                let b = item.createdAt.split(' ')[1].split(':')
                                let date = new Date(Date.UTC(a[0], parseInt(a[1]) - 1, a[2], b[0], b[1], b[2]))

                                let formateDate = [fn(date.getDate()) + '.' + fn((date.getMonth() + 1)) + '.' + date.getFullYear(),
                                fn(date.getHours()) + ':' + fn(date.getMinutes()) + ':' + fn(date.getSeconds())];
                                let pointName = '';
                                if (item.type === 'points') {
                                    pointName = getPoints(langName, item.points);
                                }
                                if (typeof item.id === 'undefined') return (null)
                                const itemName = item.type === 'points' ? ('+' + item.points + ' ' + pointName): item.name;
                                return (
                                    <div className="winnersPopup__line" key={index}>
                                        <div className="winnersPopup__left">
                                            <div className="winnersPopup__circle">
                                                {item.type === 'points'
                                                    ? <div className="winnersPopup__points">{'+' + item.points}</div>
                                                    : typeof item.image !== 'undefined' && <img className='winnersPopup__img' alt='gift' src={item.image} />
                                                }
                                            </div>
                                        </div>
                                        <div className="winnersPopup__center">
                                            <div className="winnersPopup__subscriber"><a href={"https://www.instagram.com/" + item.subscriber + "/"}>{kitcut(item.subscriber, 30)}</a></div>
                                            <div className="winnersPopup__name">{hyphen(kitcut(itemName, 50))}</div>
                                        </div>
                                        <div className="winnersPopup__right">
                                            <div className="winnersPopup__date">
                                                <span>
                                                    {formateDate[0]}
                                                </span>
                                                <span>
                                                    {formateDate[1]}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )

                            })
                        }
                    </InfiniteScroll>
            }
        </PopupContainer>
    )
}